import { Icon } from '@/icons/Icon'

export type Statistic = {
  value: string | number
  label: string
  shortLabel?: string
  ignoreInReview?: boolean
}

type StatisticsProps = {
  stats: Statistic[]
}

export default function Statistics({ stats }: StatisticsProps) {
  return (
    <div className="truncate text-13 text-gray-500 dark:text-white/50">
      {stats.map((stat, index) => (
        <div
          className="flex items-center gap-3"
          key={index}
          {...(stat.ignoreInReview ? { 'data-review': 'ignore' } : {})}
        >
          <Icon name="deal" />

          <p>
            <span className="mr-0.5 font-medium text-white">{stat.value}</span>{' '}
            {stat.shortLabel ? (
              <>
                <span className="md:hidden">{stat.shortLabel}</span>
                <span className="hidden md:inline">{stat.label}</span>
              </>
            ) : (
              stat.label
            )}
          </p>
        </div>
      ))}
    </div>
  )
}
